import React from 'react';
import Menu from './component/Menu';
import Home from './component/Home';
import About from './component/About';
import Portfolio from './component/Portofolio';
import Skill from './component/Skill';
import Contact from './component/Contact';

function App() {
  React.useEffect(() => {
    const preloader = document.querySelector('#preloader');
    if (preloader) {
      preloader.remove();
    }
  }, []);
  return (
    <>
      <Menu />
      <main className="main">
        <Home />
        <About />
        <Portfolio />
        <Skill />
        <Contact />
      </main>

      <a href='#home'
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short" />
      </a>

      <div id="preloader"></div>

    </>
  );
}

export default App;
